exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.zw-kamstrup-alarm-settings .help-text {\n  color: #777;\n}\n.zw-kamstrup-alarm-settings .ui.toggle.checkbox {\n  margin-top: 0.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32a57704","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/kamstrup/AlarmSettings.vue
// module id = sZY+
// module chunks = 1